import React, { useState } from 'react';
import { ThumbsUp } from 'lucide-react';
import api from '../../services/api';

// Phase 4.3-F Volet B — Validation détaillée d'une vidéo (non bloquante).
// 4 questions séparées ; le client n'est jamais obligé de toutes répondre.
const QUESTIONS = [
  { key: 'device', q: 'Cette vidéo correspondait-elle à votre appareil ?',
    options: [['Oui', 'oui'], ['Non', 'non'], ['Partiellement', 'partiel']] },
  { key: 'app', q: 'Cette vidéo correspondait-elle à votre application ?',
    options: [['Oui', 'oui'], ['Non', 'non'], ['Partiellement', 'partiel']] },
  { key: 'steps', q: 'Avez-vous réussi à effectuer les manipulations montrées ?',
    options: [['Oui', 'oui'], ['Non', 'non'], ["Je n'ai pas trouvé les mêmes menus", 'menus_differents']] },
  { key: 'resolution', q: 'Cette vidéo a-t-elle résolu votre problème ?',
    options: [['Oui, problème résolu', 'oui'], ['Partiellement', 'partiel'], ['Non', 'non']] },
];

export const VideoValidation = ({ videoId, context = {} }) => {
  const [answered, setAnswered] = useState({}); // {key: labelChosen}
  const [open, setOpen] = useState(false);

  const answer = (questionKey, value) => {
    setAnswered((a) => ({ ...a, [questionKey]: value }));
    api.post('/assistant/video-feedback', {
      video_id: videoId, question: questionKey, answer: value, context,
    }).catch(() => {});
  };

  if (!open) {
    return (
      <button
        onClick={() => setOpen(true)}
        className="mt-2 flex items-center gap-1.5 text-[11px] text-[#B8B8BA] hover:text-[#FF6B35] transition-colors"
        data-testid="video-validation-toggle"
      >
        <ThumbsUp className="h-3.5 w-3.5" /> Cette vidéo vous a-t-elle aidé ? Donnez votre avis
      </button>
    );
  }

  return (
    <div className="mt-2 rounded-xl border border-[#3A3A3D] bg-[#111113] p-3 space-y-2.5" data-testid="video-validation">
      <p className="text-[11px] text-[#6B6B6E]">Votre avis aide Nova à mieux choisir les vidéos (facultatif).</p>
      {QUESTIONS.map((item) => (
        <div key={item.key} data-testid={`video-validation-q-${item.key}`}>
          <p className="text-xs text-[#E8E8E8] mb-1.5">{item.q}</p>
          <div className="flex flex-wrap gap-1.5">
            {item.options.map(([label, value]) => {
              const chosen = answered[item.key] === value;
              return (
                <button
                  key={value}
                  onClick={() => answer(item.key, value)}
                  disabled={answered[item.key] !== undefined}
                  className={`text-[11px] px-2.5 py-1 rounded-lg border transition-colors ${
                    chosen ? 'bg-[#FF6B35]/20 border-[#FF6B35] text-[#FF6B35]'
                    : answered[item.key] !== undefined ? 'border-[#2A2A2D] text-[#4B4B4E] cursor-default'
                    : 'bg-[#1A1A1D] border-[#3A3A3D] text-[#B8B8BA] hover:border-[#FF6B35] hover:text-[#FF6B35]'}`}
                  data-testid={`video-validation-${item.key}-${value}`}
                >
                  {label}
                </button>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
};

export default VideoValidation;
